import styled, { css } from 'styled-components';
import { breakpointsMediaUp } from '@nubank/nuds-web/styles/breakpoints';
import { spacing, nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

const getBackground = color => (color.startsWith('#') ? color : nuDSColor(color));

export const Section = styled.section`
  background-color: ${props => (props.isHeader ? getBackground(props.backgroundColor) : 'none')};
  display: block;
  justify-content: left;
  padding: ${props => (props.isHeader ? spacing('0', '0', '4x') : 0)};
  position: relative;

  ${breakpointsMediaUp('md', css`
    padding: ${props => (props.isHeader ? '72px 142px' : 0)};
  `)};
`;

Section.displayName = 'MainContentContainer';
